"use client";

import { useEffect, useState } from "react";

/**
 * Detects iOS/Android mobile and tablet devices where PDF iframe rendering
 * is broken. Does NOT match touch-enabled desktops/laptops (e.g. Surface Pro).
 * Uses the same iOS detection pattern as use-audio-devices.ts and install-prompt.tsx.
 */
export function useIsMobileOrTablet(): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      // iPad Safari reports as MacIntel but has touch
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/.test(navigator.userAgent);
    setIsMobile(isIOS || isAndroid);
  }, []);

  return isMobile;
}
